import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnsModel } from 'src/app/models/column-model';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements OnInit {
  @Input({ required : true}) colData: Array<ColumnsModel> = [];
  @Input({ required :  true}) tableData: Array<any> = [];
  @Input({ required :  false}) currentSection: any = "";
  @Input({ required :  false}) isEventDisabled: boolean = false;
  @Output() OnClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() OnClickActionEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(private router: Router,
  public commonService: CommonService) {}

  ngOnInit(): void {
  
  }

  openDetails(index: any) {
    if (this.currentSection !== 'couponList') { 
      let routerUrl = "/orders";
      if (this.currentSection !== "myorder") {
        routerUrl = "/studio-orders"
      }
      this.router.navigate([routerUrl, this.tableData[index]._id]);
    }
  }

  onClickEventTrigger(data: any) {
    this.OnClickEvent.emit(data);
  }

  openSupportModel(data: any) {
    this.OnClickActionEvent.emit({action: "supportEvent", tableData: data})
  }

   supportOpen() {
    this.commonService.openSupport();
  }

  preventDefault(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
  }

}
